import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-sv-user-scoring-questionare',
  templateUrl: './sv-user-scoring-questionare.component.html',
  styles: [
  ]
})
export class SvUserScoringQuestionareComponent implements OnInit {
  constructor() { }

  ngOnInit(): void {
  }
}
